import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea93txwfmg154xda as Result__exceptionOrNull_impl_p6xea9,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2 as pipelineStartCoroutineUninterceptedOrReturn } from './Pipeline.web.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Key_instance3cnd8e28exiq6 as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import { recoverStackTraceBridge1qu82j8ymuquf as recoverStackTraceBridge } from './StackTraceRecover.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loop($this, direct) {
  do {
    var currentIndex = $this.index_1;
    if (currentIndex === $this.interceptors_1.get_size_woubt6_k$()) {
      if (!direct) {
        // Inline function 'kotlin.Companion.success' call
        var value = $this.subject_1;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        resumeRootWith($this, tmp$ret$0);
        return false;
      }
      return true;
    }
    $this.index_1 = currentIndex + 1 | 0;
    var next = $this.interceptors_1.get_c1px32_k$(currentIndex);
    try {
      var result = pipelineStartCoroutineUninterceptedOrReturn(next, $this, $this.subject_1, $this.continuation_1);
      if (result === get_COROUTINE_SUSPENDED())
        return false;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
        resumeRootWith($this, tmp$ret$1);
        return false;
      } else {
        throw $p;
      }
    }
  }
   while (true);
}
function resumeRootWith($this, result) {
  // Inline function 'kotlin.check' call
  if (!($this.lastSuspensionIndex_1 >= 0)) {
    var message = 'No more continuations to resume';
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  }
  var next = ensureNotNull($this.suspensions_1[$this.lastSuspensionIndex_1]);
  var _unary__edvuaz = $this.lastSuspensionIndex_1;
  $this.lastSuspensionIndex_1 = _unary__edvuaz - 1 | 0;
  $this.suspensions_1[_unary__edvuaz] = null;
  var interceptor = next.get_context_h02k06_k$().get_y2st91_k$(Key_instance);
  var tmp;
  if (interceptor instanceof CoroutineDispatcher()) {
    tmp = interceptor.isDispatchNeeded_ft82v4_k$(next.get_context_h02k06_k$()) ? intercepted(next) : next;
  } else {
    tmp = intercepted(next);
  }
  var toResume = tmp;
  var exception = Result__exceptionOrNull_impl_p6xea9(result);
  if (exception == null) {
    toResume.resumeWith_rk9gbt_k$(result);
  } else {
    var recoveredException = recoverStackTraceBridge(exception, next);
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(recoveredException));
    toResume.resumeWith_rk9gbt_k$(tmp$ret$3);
  }
}
function discardLastRootContinuation($this) {
  // Inline function 'kotlin.check' call
  if (!($this.lastSuspensionIndex_1 >= 0)) {
    var message = 'No more continuations to resume';
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  }
  var _unary__edvuaz = $this.lastSuspensionIndex_1;
  $this.lastSuspensionIndex_1 = _unary__edvuaz - 1 | 0;
  $this.suspensions_1[_unary__edvuaz] = null;
}
var SuspendFunctionGun$continuation$1Class;
function SuspendFunctionGun$continuation$1() {
  if (SuspendFunctionGun$continuation$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.currentIndex_1 = -2147483648;
      }
      get_context_h02k06_k$() {
        var inductionVariable = this.this$0__1.lastSuspensionIndex_1;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var cont = this.this$0__1.suspensions_1[index];
            if (!(cont === this) && !(cont == null))
              return cont.get_context_h02k06_k$();
          }
           while (0 <= inductionVariable);
        // Inline function 'kotlin.error' call
        var message = 'Not started';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      resumeWith_lgtnnr_k$(result) {
        // Inline function 'kotlin.onFailure' call
        var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(tmp0_safe_receiver));
          resumeRootWith(this.this$0__1, tmp$ret$4);
          return Unit_instance;
        }
        loop(this.this$0__1, false);
      }
      resumeWith_rk9gbt_k$(result) {
        return this.resumeWith_lgtnnr_k$(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    SuspendFunctionGun$continuation$1Class = $;
  }
  return SuspendFunctionGun$continuation$1Class;
}
var SuspendFunctionGunClass;
function SuspendFunctionGun() {
  if (SuspendFunctionGunClass === VOID) {
    class $ extends PipelineContext() {
      constructor(initial, context, interceptors) {
        super(context);
        this.interceptors_1 = interceptors;
        var tmp = this;
        tmp.continuation_1 = new (SuspendFunctionGun$continuation$1())(this);
        this.subject_1 = initial;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.interceptors_1.get_size_woubt6_k$();
        tmp_0.suspensions_1 = Array(size);
        this.lastSuspensionIndex_1 = -1;
        this.index_1 = 0;
      }
      get_coroutineContext_115oqo_k$() {
        return this.continuation_1.get_context_h02k06_k$();
      }
      get_subject_tmjbgd_k$() {
        return this.subject_1;
      }
      *proceed_tynop7_k$($completion) {
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var tmp0 = $completion;
          var tmp$ret$1;
          $l$block_0: {
            if (this.index_1 === this.interceptors_1.get_size_woubt6_k$()) {
              tmp$ret$1 = this.subject_1;
              break $l$block_0;
            }
            this.addContinuation_71x8tk_k$(tmp0);
            if (loop(this, true)) {
              discardLastRootContinuation(this);
              tmp$ret$1 = this.subject_1;
              break $l$block_0;
            }
            tmp$ret$1 = get_COROUTINE_SUSPENDED();
          }
          return tmp$ret$1;
        };
      }
      *proceedWith_i5skhv_k$(subject, $completion) {
        this.subject_1 = subject;
        return yield* this.proceed_tynop7_k$($completion);
      }
      *execute_pc5rz_k$(initial, $completion) {
        this.index_1 = 0;
        if (this.index_1 === this.interceptors_1.get_size_woubt6_k$())
          return initial;
        this.subject_1 = initial;
        // Inline function 'kotlin.check' call
        if (!(this.lastSuspensionIndex_1 < 0)) {
          var message = 'Already started';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return yield* this.proceed_tynop7_k$($completion);
      }
      addContinuation_71x8tk_k$(continuation) {
        this.lastSuspensionIndex_1 = this.lastSuspensionIndex_1 + 1 | 0;
        this.suspensions_1[this.lastSuspensionIndex_1] = continuation;
      }
    }
    initMetadataForClass($, 'SuspendFunctionGun', VOID, VOID, VOID, [0, 1]);
    SuspendFunctionGunClass = $;
  }
  return SuspendFunctionGunClass;
}
//region block: exports
export {
  SuspendFunctionGun as SuspendFunctionGun278ui80hj12zj,
};
//endregion

//# sourceMappingURL=SuspendFunctionGun.mjs.map
